<!--Displays an image and up to five recent listings in a particular blog.-->

<template>
  <div v-if="!loading">
    <img class="img-fluid" :src="img" alt="Source News Picture" />
    <mdb-row class="mb-3"></mdb-row>
    <div class="d-flex justify-content-between news">
      <mdb-col col="11" class="text-truncate pl-0 mb-3">
        <h5 class="font-weight-bold">{{title}}</h5>
      </mdb-col>
    </div>
    <div v-for="listing in posts.items" :key="listing.id">
      <router-link :to="'/'+'articleblogpage'+'/'+listing.meta.slug">
        <div class="d-flex justify-content-between news">
          <mdb-col col="11" class="text-truncate pl-0 mb-3">
            <a>{{listing.title}}</a>
          </mdb-col>
          <a>
            <mdb-icon icon="angle-double-right" />
          </a>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mdbRow, mdbCol, mdbIcon} from "mdbvue";
import axios from "axios";
import api from "@/api"

export default {
  props: {
    parent_page: Object,
    numberOfPosts: {
      type: [Number],
      default: 5
    },
    child_page_types: {
      type: [String],
      default: "blog.BlogDetailPage"
    },
    title: String,
    img: String,
    text_class: String
  },
  name: "recent_docs",
  components: {
    mdbRow,
    mdbCol,
    mdbIcon
  },
  data() {
    return {
      loading: true,
      posts: false
    };
  },
  computed: {
    axiosParams() {
      const params = new URLSearchParams();
      params.append("fields", "*");
      params.append("type", this.child_page_types);
      params.append("descendant_of", this.parent_page.id);
      params.append("limit", this.numberOfPosts);
      params.append("order",'-id')
      return params;
    },
  },
  methods: {
    getData() {
      axios
        api.get("pages/", {
          params: this.axiosParams
        })
        .then(response => {
          this.posts = response.data;
        })
        .catch(e => {
          this.errors.push(e);
        })
        .finally(() => {
          this.loading = false;
        })
    },
  },
  mounted() {
    this.getData();
  }
};
</script>